import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppLayoutService } from '../../app-layout.service';
import { IHeaderAction } from '../../interfaces';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-actions',
  templateUrl: './header-actions.component.html',
  styleUrls: ['./header-actions.component.scss'],
})
export class HeaderActionsComponent implements OnInit, OnDestroy {
  public actions: IHeaderAction[] = [];

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private appLayoutService: AppLayoutService, private router: Router) {}

  public ngOnInit(): void {
    this.appLayoutService.headerActions$
      .pipe(takeUntil(this.isDestroy))
      .subscribe(
        (actions: IHeaderAction[]) => (this.actions = actions?.sort((a: IHeaderAction, b: IHeaderAction) => (a.id > b.id ? 1 : -1))),
      );
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public openAction(item: IHeaderAction): void {
    if (!!item.action) {
      item.action();
    } else {
      this.router.navigate(item.routerLink);
    }
  }
}
